export default [
  { value: 'Mail', label: 'Mail' },
  { value: 'API', label: 'API' },
  { value: 'Manual', label: 'Manual' }
];
